<template>
  <Content>
    <slot>main layout empty</slot>
  </Content>
</template>

<script>
import { Content } from '@neurotrack/web-shared-components'

export default {
  name: 'PrimaryLayout',
  components: { Content }
}
</script>
